import { render, staticRenderFns } from "./DocumentationList.vue?vue&type=template&id=0f60a4a5&"
import script from "./DocumentationList.vue?vue&type=script&lang=js&"
export * from "./DocumentationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports